<template>
  <nav class="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
            <div class="container">
                <a class="navbar-brand" href="#page-top">
                    <img src="@/assets/img/logo-barocio-asociados.png" alt="Logo Barocio & Asociados" class="img-fluid" width="50" height="60" />
                    Barocio & Asociados
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                    Menú
                    <i class="fas fa-bars ms-1"></i>
                </button>
                <div class="collapse navbar-collapse" id="navbarResponsive">
                    <ul class="navbar-nav text-uppercase ms-auto py-4 py-lg-0">
                        <li class="nav-item"><a class="nav-link" href="#services" title="Asesoría Legal">Asesoría</a></li>
                        <li class="nav-item"><a class="nav-link" href="#tramites" title="Tramites Legales">Tramites</a></li>
                        <li class="nav-item"><a class="nav-link" href="#about" title="Sobre el Despacho">Despacho Legal</a></li>                        
                        <li class="nav-item"><a class="nav-link" href="#contact" title="Agenda tu cita">Contacto</a></li>
                    </ul>
                </div>
            </div>
        </nav>
</template>

<script>
export default {
  name: 'NavBar',
};
</script>

<style scoped>
/* Add any specific styles for the NavBar here if needed */
</style>
